import { Component, OnInit, OnDestroy, Injector, ViewChild} from '@angular/core';
import { forkJoin, Subscription } from 'rxjs';

import CustomStore from 'devextreme/data/custom_store';
import DataSource from 'devextreme/data/data_source';

// components
import { FullListComponent } from '../../../shared/components/full-list/full-list.component';
import { DistributionNumberRangeComponent } from './distribution-number-range.component';

// models
import { DistributionNumberRange } from '../../../shared/models/distribution-number-range';

// services
import { DistributionManagementService } from '../../shared/services/distribution-management.service';
import { MasterDataService } from '../../shared/services/master-data.service';
import { TranslateService } from '@ngx-translate/core';
import { DxDataGridComponent } from 'devextreme-angular';



@Component({
  selector: 'distribution-number-ranges-component',
  templateUrl: 'distribution-number-ranges.component.html',
  styleUrls: ['./distribution-number-ranges.component.scss']
})
export class DistributionNumberRangesComponent extends FullListComponent<DistributionNumberRange, DistributionNumberRangeComponent> implements OnInit, OnDestroy {

  @ViewChild('confirmation') confirmation: any;
  @ViewChild('details') detailsComponent: DistributionNumberRangeComponent;
  @ViewChild('distributionNumberRangesGrid') dataGridInstance: DxDataGridComponent;


  rtlEnabled = localStorage.getItem('last-selected-language-direction') ? JSON.parse(localStorage.getItem('last-selected-language-direction')) : false;
  private _subscription: Subscription;
  distributionNumberRangeDataSource = {};
  masterDataLookupSource = {};

  editingEnabled = true;

  constructor(
    protected injector: Injector,
    private distributionManagementService: DistributionManagementService,
    private masterDataService: MasterDataService,
    private translateService: TranslateService,
  ) {
    super(injector, DistributionNumberRange);
    this._subscription = this.language.direction.subscribe(dir => {
      this.rtlEnabled = dir;
    });


    this.masterDataLookupSource = {
      store: new CustomStore({
              key: 'masterDataListRowId', 
              load: (loadOptions) => {
                return this.masterDataService.getSysMasterDataListForDropdown(15/*DistributionCategory*/, 
                  this.id, this.translateService.currentLang, null, loadOptions).toPromise();
              },
              byKey: async (key) => {
                var result = await this.masterDataService.getSysMasterDataListForDropdown(15/*DistributionCategory*/, 
                  this.id, this.translateService.currentLang, key, null).toPromise();
                  return result.data[0];
              }
            }
          )
        };

        
    this.distributionNumberRangeDataSource = new DataSource({
        paginate: true,
        requireTotalCount: true,
        store: new CustomStore({            
          key: "distributionNumberRangeId",
          load: async (loadOptions) => {
            var result = await this.distributionManagementService.getDistributionNumberRangesPaged(this.id, loadOptions).toPromise();
            return { data: result.data, totalCount: result.totalCount };
          },
        }),
      
    });
  }

  ngOnInit() {
    this.title.set('DISTRIBUTION_MANAGEMENT.DISTRIBUTION_NUMBER_RANGES_TITLE');
    this.setTranslations('DISTRIBUTION_MANAGEMENT');

    this.distributionManagementService.checkDeletePossible(this.id)
      .subscribe(_ => {
        this.editingEnabled = true;
      },
        error => {
          this.editingEnabled = false;
          this.spinner.hide();
        });
  }

  ngOnDestroy() {
    super.ngOnDestroy();
    this._subscription.unsubscribe();
  }



  edit = (e: any) => {
    if(!this.editingEnabled)
    {
      return;
    }
    const distributionRangeId = e.row !== undefined ? e.row.data.distributionNumberRangeId : e.data.distributionNumberRangeId;
    this.detailsComponent.modalTitle = this.translations.EDIT;
    this.detailsComponent.open(distributionRangeId, this.id);
  }

  add() {
    this.detailsComponent.modalTitle = this.translations.ADD_NEW;
    this.detailsComponent.open(null, this.id);
  }

  deleteItem = (e: any) => {
    this.distributionManagementService.checkDeletePossible(this.id)
      .subscribe(_ => {
        this.itemIdToDelete = e.row.data.distributionNumberRangeId;
    this.confirmation.opened = true;
      },
        error => {
          this.errorService.show(error);
          this.spinner.hide();
        });
    
  }

  deleteSelected() {
    this.spinner.show();
    this.distributionManagementService.deleteDistributionNumberRange(this.id, this.itemIdToDelete)
      .subscribe(_ => {
        this.dataGridInstance.instance.refresh();
        this.spinner.hide();
      },
        error => {
          this.errorService.show(error);
          this.spinner.hide();
        });
  }

  onDetailsComponentClosed(isDataChanged: boolean) {
    if (isDataChanged) {
      this.dataGridInstance.instance.refresh();
    }
  }
}
